import React from 'react';
import { DebouncedInput } from '../../Components';
import { WithProductsSearch } from './WithProductsSearch';

export const WithProductsSearchWithInput = ({ ...props }) => (
    <WithProductsSearch
      {...props}
      renderInputComponent={({ search, handleSearch }) => (
        <DebouncedInput value={search} onChange={handleSearch} />
      )}
    />
);
